let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2prqJ")).then(() => parcelRequire('1ElO6'));